/**
 * @generated SignedSource<<0d2d85786105620623dcdd19e556caf3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptPanel_Transcript_meetingRecording$data = {
  readonly __typename: string;
  readonly activeSummary?: {
    readonly id: string;
  } | null;
  readonly canRegenerateSummary?: boolean;
  readonly comments?: ReadonlyArray<{
    readonly count: number;
    readonly endTimestamp: string;
    readonly startTimestamp: string;
    readonly threadId: number;
    readonly users: ReadonlyArray<{
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly isExternal: boolean;
    }>;
  }>;
  readonly id: string;
  readonly meetingRecordedVideoUrl: string | null;
  readonly ownerAccount: {
    readonly __typename: string;
  };
  readonly showLowLanguageConfidenceRegenerationBanner?: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"Timeline_meetingKeyEvents" | "TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording" | "TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording" | "TranscriptPanel_TranscriptSegment_meetingRecording" | "TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording" | "TranscriptPanel_makeSpeakerNameToUserMapping_meetingRecording">;
  readonly " $fragmentType": "TranscriptPanel_Transcript_meetingRecording";
};
export type TranscriptPanel_Transcript_meetingRecording$key = {
  readonly " $data"?: TranscriptPanel_Transcript_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_Transcript_meetingRecording">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "public",
    "variableName": "public"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "public"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptPanel_Transcript_meetingRecording",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoUrl",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingRecordingSummary",
          "kind": "LinkedField",
          "name": "activeSummary",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canRegenerateSummary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingRecordingCommentsData",
          "kind": "LinkedField",
          "name": "comments",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "threadId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startTimestamp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endTimestamp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "users",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fullName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "image",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isExternal",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showLowLanguageConfidenceRegenerationBanner",
          "storageKey": null
        }
      ],
      "type": "MeetingRecording",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerAccount",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_TranscriptSegment_meetingRecording"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Timeline_meetingKeyEvents"
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_makeSpeakerNameToUserMapping_meetingRecording"
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_RelabelMultipleSpeakersModal_meetingRecording"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_UnlabeledSpeakersWarning_meetingRecording"
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording"
    }
  ],
  "type": "MeetingRecordingInterface",
  "abstractKey": "__isMeetingRecordingInterface"
};
})();

(node as any).hash = "8a250bf480673b7358fa18dfbe07b122";

export default node;
